<div class="h-full">
    <app-ongletlayout
        storageId="parametres-activites"
        [ongletLinks]="tableLinkForActivities"
        (onClickMenu)="onCloseLocalStorage()"
    >
        <div>
            <router-outlet></router-outlet>
        </div>
    </app-ongletlayout>
</div>